/**
 * fixed sidevar
*/
const $sidenavi = $(".js-fixed-sidenavi");
if ($sidenavi.length > 0) {
    const bottomMargin = 70;
    const boundaryMiddleWindow = 1265;
    const trigger = $('.js-side-accordion-trigger');
    const content = $('.js-side-accordion-content');


    $(window).on('load scroll resize', function () {
        const windowWidth = window.innerWidth;
        const buffer = 0;
        const fixedObjectBufferMargin = (windowWidth <= boundaryMiddleWindow) ? -1 * $sidenavi.height() - buffer : -100;
        const fixedObjectBufferPadding = (windowWidth <= boundaryMiddleWindow) ? $sidenavi.height() + buffer : 100;
  
        let scroll = $(document).scrollTop();
        let scrollLeft = $(document).scrollLeft();
        let sideHeight = $sidenavi.outerHeight();
        let sideMarginTop = 0;
        let sideMarginBottom = 50;
        let footerTop = $(".global_footer").offset().top;

        const contentTop = $("main").offset().top;
        const contentLeft = $(".has-fixed-menu .area-inner._narrow").offset().left;
        const left = (windowWidth <= boundaryMiddleWindow) ? contentLeft : 'auto';
        const right = (windowWidth <= boundaryMiddleWindow) ? 'auto' : 0;
        const topMargin = (windowWidth <= boundaryMiddleWindow) ? 0 : 50;

        if (windowWidth > boundaryMiddleWindow) {
            sideMarginTop = 50;
            content.show();
        }else{
            $sidenavi.addClass('is-trans');
        }

        if (scroll > (footerTop - sideMarginBottom - sideMarginTop - sideHeight)) {
            $sidenavi.css({
                'position': 'absolute',
                'top': 'auto',
                'bottom': bottomMargin,
                'left': left,
                'right': right
            });
        } else if (scroll > (contentTop - sideMarginTop)) {
            $sidenavi.css({
                'position': 'fixed',
                'top': topMargin,
                'bottom': 'auto',
                'left': left,
                'right': right
            },
            {
                'position': 'absolute',
                'top': 0,
                'bottom': 'auto',
                'left': left,
                'right': right
            });
        } else {
            $sidenavi.css({
                'position': 'absolute',
                'top': 0,
                'bottom': 'auto',
                'left': left,
                'right': right
            });
        }

        // content.find('a').each(function () {
        //     const id = $(this).attr('href');
        //     if (id.match(/^#/)) {
        //         $(id).css({
        //             'margin-top': fixedObjectBufferMargin,
        //             'padding-top': fixedObjectBufferPadding
        //         })
        //     }
        // })

        const links = $('.inner-link');

        if (content.length > 0) {
            links.find('a').each(function () {
                const id = $(this).attr('href');
                if (id.match(/^#/)) {
                    $(id).css({
                        'margin-top': fixedObjectBufferMargin,
                        'padding-top': fixedObjectBufferPadding
                    })
                }
            })
        }
    });

    trigger.on('click', function () {
        const windowWidth = window.innerWidth;
        if (windowWidth <= boundaryMiddleWindow){
            if ($(this).hasClass('_is-active')) {
                content.slideUp(200);
                $(this).removeClass('_is-active');
            } else {
                content.slideDown(200);
                $(this).addClass('_is-active');
            }
            return false;
        } 
    });

    content.find('a').on('click', function () {
        const windowWidth = window.innerWidth;
        if (windowWidth <= boundaryMiddleWindow) {
            content.slideUp();
            trigger.removeClass('_is-active');
        }
    })
}
